import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { Button } from 'components/design-system'
import s from './styles.module.css'

import kickoffLogoDark from 'images/kickoff-logo-dark.svg'
import {
  ArrowRightIcon,
  CheckmarkCircleIcon,
} from 'components/design-system/kickoff-icons'
import { DEFAULT_VALUE_PROPS, VALUE_PROPS_BY_CATEGORY } from './constants'
import { LandingPageExperimentAnalytics } from 'components/homepage/experiment/analytics'
import urls from 'utilities/urls'

export const CTA = ({ category }: { category?: string }) => {
  const { query } = useRouter()

  const valueProps = VALUE_PROPS_BY_CATEGORY[category] || DEFAULT_VALUE_PROPS

  const handleSignUpClick = () => {
    LandingPageExperimentAnalytics.onClick({
      signUpVariant: null,
      location: `Blog Post - Mid Post CTA`,
    })
  }

  const href = useMemo(() => {
    return urls.clientSignUp({
      ref: 'blog_freetrial',
      gclid: query.gclid,
      msclkid: query.msclkid,
      utm_campaign_id: query?.utm_campaign_id || null,
      utm_campaign: query?.utm_campaign || 'blog',
      utm_medium: query?.utm_medium || 'blog',
      utm_content: query?.utm_content || null,
    }).href
  }, [
    query.gclid,
    query.msclkid,
    query.utm_campaign,
    query.utm_campaign_id,
    query.utm_content,
    query.utm_medium,
  ])

  return (
    <aside className={s.ctaRoot}>
      <div className={s.innerContainer}>
        <div className={s.logoContainer}>
          <img src={kickoffLogoDark} alt="Kickoff" className={s.logo} />
        </div>
        <span className={s.title}>Start your 7 day free trial</span>
        <Button
          className={s.ctaBtn}
          iconRight={<ArrowRightIcon />}
          interactive
          onClick={handleSignUpClick}
          to={href}>
          Find your coach
        </Button>
        <div className={s.valuePropsContainer}>
          {valueProps.map(valueProp => (
            <span key={valueProp} className={s.valueProp}>
              <CheckmarkCircleIcon size="small" />
              <span className={s.valuePropText}>{valueProp}</span>
            </span>
          ))}
        </div>
      </div>
    </aside>
  )
}
